"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9877],{

/***/ 39877:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ Header_HeaderBlock; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Header/Header.tsx
var Header = __webpack_require__(22690);
;// CONCATENATED MODULE: ./src/blocks/Header/HeaderBlock.tsx



const HeaderBlock = (param)=>{
    let { blockData  } = param;
    const { data  } = blockData;
    const [{ header_orange ="" , header ="" , sneakpeak ="" , content ="" , subheader ="" , background ="" , reduce_top_margin , reduce_bottom_margin , className =""  }] = data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
            className: className,
            coloredTop: header_orange,
            header: header,
            boldText: sneakpeak,
            info: content,
            infoHtml: true,
            info2: subheader,
            background: background,
            marginTop: reduce_top_margin,
            marginBottom: reduce_bottom_margin
        })
    });
};
/* harmony default export */ var Header_HeaderBlock = (HeaderBlock);

;// CONCATENATED MODULE: ./src/blocks/Header/index.ts



/***/ }),

/***/ 15849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const Divider = (param)=>{
    let { color ="#fbbb21" , width ="8.4375rem" , className =""  } = param;
    const styles = {
        width: "".concat(width),
        backgroundColor: color
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "divider ".concat(className),
        style: styles
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Divider);


/***/ }),

/***/ 22690:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Divider_Divider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15849);



const Header = (param)=>{
    let { className ="" , header , header2 , boldText , info , info2 , info3 , inverted , infoHtml , background , white , coloredTop , marginTop , marginBottom  } = param;
    const reduceMargin = {
        paddingTop: marginTop + "px",
        paddingBottom: marginBottom + "px"
    };
    const backgroundClass = background === "grey" ? "mainBackgroundGrey" : "";
    const infoToDisplay = info && (infoHtml ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "headerComponent__info",
        dangerouslySetInnerHTML: {
            __html: info
        }
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
        className: "headerComponent__info",
        children: info
    }));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: reduceMargin,
        className: "headerComponent ".concat(className, " ").concat(backgroundClass, " ").concat(white ? "white" : ""),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "desktop-container",
            children: [
                coloredTop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: "headerComponent__coloredTop",
                    children: coloredTop
                }),
                header && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                    className: "headerComponent__header",
                    dangerouslySetInnerHTML: {
                        __html: header
                    }
                }),
                header2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "headerComponent__header headerComponent__header2",
                    children: header2
                }),
                inverted && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Divider_Divider__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}),
                boldText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "headerComponent__bold",
                    children: boldText
                }),
                info && infoToDisplay,
                info2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                    className: "headerComponent__info headerComponent__info2 ".concat(backgroundClass),
                    children: info2
                }),
                info3 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "headerComponent__info",
                    children: info3
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Header);


/***/ })

}]);